// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpTagviewmgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpTagviewmgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpTagviewmgrIconOutlined = function DrrpTagviewmgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpTagviewmgrIconOutlinedSvg
  }));
};

DrrpTagviewmgrIconOutlined.displayName = 'DrrpTagviewmgrIconOutlined';
export default React.forwardRef(DrrpTagviewmgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpTagviewmgrIconOutlined.js
// module id = 2581
// module chunks = 0